// extracted by mini-css-extract-plugin
export default {"footerLinks":"c-g_bZ"};